<template>
<v-container fluid fill-height class="pa-0">
    <v-layout v-if="errorMessage">
        <v-flex>
            <v-alert 
                :value="true" 
                outline 
                type="error">
                <span>{{ errorMessage }}</span>
            </v-alert>
        </v-flex>
    </v-layout>
    <loading v-if="loading"></loading>
    <v-layout v-if="!loading && !errorMessage">
        <v-flex>
            <PlantConfigurationInductionsTable :data="plantInductions" @edit="openEdit"></PlantConfigurationInductionsTable>
        </v-flex>
    </v-layout>
    <PlantConfigurationInductionsAddEdit
        v-if="showAddEditDialog"
        :plantID="plantID"
        :show="showAddEditDialog"
        :originalItem="editedItem"
        @close="onAddEditClose"
        >
    </PlantConfigurationInductionsAddEdit>
</v-container>
</template>

<script>
import BaseAPI from "@/api/baseApi";
import plantConfigurationApi from '@/api/plantConfigurationApi'
import Loading from '@/components/generic/Loading.vue';
import PlantConfigurationInductionsTable from '@/components/plants/configuration/PlantConfigurationInductionsTable.vue'
import PlantConfigurationInductionsAddEdit from '@/components/plants/configuration/PlantConfigurationInductionsAddEdit.vue'

export default {
    props: {
        plantID: {
            required: true,
            type: Number
        }
    },
    components: {
        Loading,
        PlantConfigurationInductionsTable,
        PlantConfigurationInductionsAddEdit
    },
    data() {
        return {
            errorMessage: null,
            loading: false,
            showAddEditDialog: false,
            editedItem: null,
            plantInductions: []
        };
    },
    methods: {
        async loadData() {
            try {
                this.loading = true;

                this.plantInductions = await plantConfigurationApi.getPlantInductions(this.plantID);                
            }
            catch (err) {
                this.errorMessage = await BaseAPI.parseHttpRequestError(err);

                throw err;
            }
            finally {
                this.loading = false;
            }
        },
        async openEdit(item) {
            this.editedItem = item;
            this.showAddEditDialog = true;
        },
        async onAddEditClose(saved) {
            this.showAddEditDialog = false;            

            if (saved === true) {
                await this.loadData();
            }
        }
    },
    created() {
        this.loadData();
    }
}
</script>

<style>

</style>
